import { render } from "./business-info.vue?vue&type=template&id=0dd41a7e&scoped=true"
import script from "./business-info.vue?vue&type=script&lang=js"
export * from "./business-info.vue?vue&type=script&lang=js"

import "./business-info.vue?vue&type=style&index=0&id=0dd41a7e&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dd41a7e"]])

export default __exports__